import { PageHero } from "@/components/PageHero";

const SECTIONS = [
  { h: "Acceptance of Terms", p: "By accessing this website and purchasing our products, you agree to these Terms. If you do not agree, please do not use the site." },
  { h: "Use of Content", p: "All content — including the book, course materials, articles, and brand assets — is the property of Employee 2 Employer and is provided for your personal use. You may not reproduce or resell it without permission." },
  { h: "Purchases", p: "Prices are listed in U.S. dollars. Digital products are delivered electronically. Please review your order before completing a purchase." },
  { h: "Refunds", p: "Digital products may be covered by a satisfaction guarantee as stated at the point of purchase. Contact us within the stated window to request a refund." },
  { h: "No Guarantees", p: "Our materials are educational. We share principles and frameworks in good faith, but we make no guarantee of specific financial or personal outcomes. Your results depend on your own effort and circumstances." },
  { h: "Contact", p: "Questions about these Terms? Reach us through the Contact page." },
];

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHero eyebrow="Legal" title="Terms of Service" testId="terms-hero" />
      <section className="bg-white text-black py-24 lg:py-32">
        <div className="max-w-[820px] mx-auto px-6 lg:px-10 space-y-12">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="font-display text-2xl lg:text-3xl">{s.h}</h2>
              <p className="font-body text-lg text-black/65 mt-4 leading-relaxed">{s.p}</p>
            </div>
          ))}
          <p className="font-body text-sm text-black/40 pt-6 border-t border-[#e5e5e5]">
            Last updated {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long" })}.
          </p>
        </div>
      </section>
    </div>
  );
}
